<div class="mat-dialog-content">
    <!-- <div class="column-input">
        <label> {{ 'aumico_notes_super_table_add_free_column_title_placeholder' | i18next }} </label>
        <input
            hamInput
            placeholder=" {{ 'aumico_notes_super_table_enter_here' | i18next }}"
            [formControl]="form.controls['title']"
        />
    </div> -->
    <div *ngIf="form.controls['title'].touched && form.controls['title'].invalid" class="error-message">
        <span *ngIf="form.controls['title'].errors['required']"
            >{{ 'aumico_annual_report_mandatory_field_error' | i18next }}
        </span>
    </div>
    <div class="column-input">
        <input
            placeholder="{{ 'aumico_notes_super_table_select_from_here' | i18next }}"
            [options]="dataTypeSelections"
            hamSimpleDropDown
            [optionKeys]="['name']"
            returnKey="id"
            [returnObject]="true"
            [multiple]="false"
            [formControl]="form.get('dataType')"
            [label]="'aumico_notes_super_table_add_free_column_col_type' | i18next"
            [showRequired]="true"
        />

        <div *ngIf="form.controls['dataType'].touched && form.controls['dataType'].invalid" class="error-message">
            <span *ngIf="form.controls['dataType'].errors['required']"
                >{{ 'aumico_annual_report_mandatory_field_error' | i18next }}
            </span>
        </div>
    </div>
    <div class="column-input column-width-input">
        <span class="ham-icon" (click)="showInfoDialog = true">
            <i class="info-outline-icon"></i>
        </span>
        <input
            placeholder="{{ 'aumico_notes_super_table_enter_here' | i18next }}"
            [options]="columnWidthSelections"
            hamSimpleDropDown
            [optionKeys]="['name']"
            returnKey="id"
            [returnObject]="true"
            [multiple]="false"
            [formControl]="form.get('columnWidth')"
            [label]="'aumico_notes_super_table_add_column_width' | i18next"
            [showRequired]="true"
        />

        <div
            *ngIf="form.controls['columnWidth'].touched && form.controls['columnWidth'].invalid"
            class="error-message"
        >
            <span *ngIf="form.controls['columnWidth'].errors['required']"
                >{{ 'aumico_annual_report_mandatory_field_error' | i18next }}
            </span>
        </div>
    </div>
    <div class="column-input">
        <input
            placeholder="{{ 'aumico_notes_super_table_select_from_here' | i18next }}"
            [options]="belongingYearSelections"
            hamSimpleDropDown
            [optionKeys]="['name']"
            returnKey="id"
            [returnObject]="true"
            [multiple]="false"
            [formControl]="form.get('belongingYear')"
            [label]="'aumico_notes_super_table_add_free_column_belonging_year' | i18next"
            [showRequired]="true"
        />

        <div
            *ngIf="form.controls['belongingYear'].touched && form.controls['belongingYear'].invalid"
            class="error-message"
        >
            <span *ngIf="form.controls['belongingYear'].errors['required']"
                >{{ 'aumico_annual_report_mandatory_field_error' | i18next }}
            </span>
        </div>
    </div>
</div>
<!-- Info Dialog for Column-widths -->
<ham-modal
    *ngIf="showInfoDialog"
    [saveText]="'aumico_notes_info_dialog_column_done' | i18next"
    (cancel)="showInfoDialog = false"
    (save)="showInfoDialog = false"
    [size]="'default'"
    [title]="'aumico_notes_info_dialog_column_title' | i18next"
>
    <span [innerHTML]="'aumico_notes_info_dialog_column_text1' | i18next"></span>
    <br /><br />
    <span [innerHTML]="'aumico_notes_info_dialog_column_text2' | i18next"></span>
</ham-modal>
